<template>
  <el-dialog title="VNPT Smart CA" :visible.sync="isOpen" width="60%" :before-close="handleClose">
    <template #title>
      <div>
        <img width="35" height="35" src="@/assets/images/vnptca.svg" alt="">
        <span class="text-lg font-semibold ml-2" style="color: rgb(2 113 177);">
          Xác thực ký
        </span>
      </div>
    </template>
    <!-- Content -->
    <div class="content" v-loading="loading" element-loading-text="Đang kiểm tra dữ liệu ký ..."
      element-loading-spinner="el-icon-loading">
      <el-row :gutter="20">
        <el-col :span="14">
          <h3>Yêu cầu xác thực ký đã được gửi về {{ selectedCredential.device.branch }} - {{
            selectedCredential.device.name
          }}</h3>
          <!-- Countdown -->
          <div class="countdown p-3 my-3" style="background-color: rgba(2, 113, 177, 0.1); border-radius: 10px;">
            <p class="text-center">
              Thời gian còn lại
            </p>
            <div class="flex items-center justify-center gap-1">
              <p class="text-center text-2xl font-semibold" style="color: rgb(2 113 177); margin-bottom: 0px!;">
                {{ timeLeft }}
              </p>
              <p class="text-lg font-medium" style="color: rgb(2 113 177);">s</p>
            </div>
          </div>
          <p>Để hoàn thành ký hồ sơ, mở ứng dụng <strong>VNPT Smart CA</strong> và xác thực.</p>
          <!-- Device info -->
          <p class="mt-3">Thiết bị: <strong>{{ selectedCredential.device.branch }} - {{ selectedCredential.device.name
          }}</strong></p>
          <p>Ứng dụng: <strong>{{ selectedCredential.device.appName }}</strong></p>
          <el-button class="fs-16" size="small" plain type="primary" @click="refresh">Refresh</el-button>
        </el-col>
        <el-col :span="10">
          <div class="instruction">
            <img height="300" style="width: 80%;" :src="instructionImgs[currentInstruction]"
              class="instruction-image" />
          </div>
        </el-col>
      </el-row>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="fs-16" size="small" plain type="primary" @click="handleClose">Đóng</el-button>
    </span>
  </el-dialog>
</template>

<script>
import SignatureRequest from '@/api/request/SignatureRequest'
export default {
  name: 'ModalVnptCAConfirm',
  data () {
    return {
      isOpen: false,
      loading: false,
      selectedCredential: null,
      timer: null,
      timeLeft: 190,
      timerInstruction: null,
      currentInstruction: 0,
      instructionImgs: [
        require('@/assets/images/instruction_1.svg'),
        require('@/assets/images/instruction_2.svg'),
        require('@/assets/images/instruction_3.svg'),
        require('@/assets/images/instruction_4.svg')
      ],
      docdata: null,
      tranId: null
    }
  },
  watch: {
    timeLeft (newVal) {
      if (newVal && newVal == 0) {
        this.timeLeft = 0
        this.refresh()
        clearInterval(this.timer)
      }
    }
  },
  methods: {
    async handleOpen (docdata, tranId, selectedCredential) {
      this.isOpen = true
      this.docdata = docdata
      this.tranId = tranId
      this.selectedCredential = selectedCredential || null
      this.currentInstruction = 0
      this.startTime()
      this.startInstruction()
    },
    handleClose () {
      clearInterval(this.timer)
      clearInterval(this.timerInstruction)
      this.isOpen = false
    },
    startTime () {
      this.timer = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--
        } else {
          clearInterval(this.timer)
        }
      }, 1000)
    },
    startInstruction () {
      this.timerInstruction = setInterval(() => {
        this.currentInstruction = (this.currentInstruction + 1) % this.instructionImgs.length
      }, 3000)
    },
    async refresh () {
      this.loading = true
      const request = new SignatureRequest()
      await request.vnptSignInfo(this.docdata, this.tranId).then(response => {
        console.log('refresh response', response)
        this.$emit('onSuccess', response.data)
      }).catch(error => {
        if (error.response.data.error == 'PENDING') {
          this.$message({
            type: 'warning',
            message: this.$t(`Vui lòng xác thực ký số trên ứng dụng ${this.selectedCredential.device.appName}!`)
          })
        } else if (error.response.data.error == 'EXPIRED') {
          this.$message({
            type: 'error',
            message: this.$t('Yêu cầu đã hết hạn hoặc không còn hiệu lực!')
          })
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .el-dialog__body {
    padding-top: 0px;
    padding-bottom: 0px;
  }
}

.instruction-image {
  transition: opacity 0.5s ease;
}
</style>